import dayjs, { Dayjs } from "dayjs";

export const getDayJs = (date?: unknown): Dayjs | null => {
  if (!date) return null;
  if (dayjs.isDayjs(date) && date.isValid()) return date;
  if (!(typeof date === "string")) return null;
  const dayJsDate = dayjs(date);
  if (!dayJsDate.isValid()) return null;
  return dayJsDate;
};

export const completeStringDate = (date?: unknown): string | null => {
  const dayJsDate = getDayJs(date);
  if (!dayJsDate) return null;
  return dayJsDate.format("DD.MM.YYYY [um] HH:mm");
};

export const compactStringDate = (date?: unknown): string | null => {
  const dayJsDate = getDayJs(date);
  if (!dayJsDate) return null;
  return dayJsDate.format("DD.MM.YYYY");
};
